import React from 'react';
import { inActionImages } from '../data/images';
import { Users, Target, MessageSquare, Zap, ArrowRight } from 'lucide-react';
import { trackCTAClick } from '../utils/analytics';

const bullets = [
  { icon: Users, text: 'Interactive and engaging sessions' },
  { icon: Target, text: 'Real-time team alignment' },
  { icon: Zap, text: 'Practical leadership development' },
  { icon: MessageSquare, text: 'Hands-on communication training' },
];

const InAction = () => {
  return (
    <section id="in-action" className="py-16 sm:py-24 bg-slate-950" data-testid="in-action-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          {/* Left: Image Grid */}
          <div className="grid grid-cols-2 gap-3 sm:gap-4">
            {inActionImages.map((img, i) => (
              <div
                key={i}
                className={`relative overflow-hidden rounded-xl group ${i === 0 ? 'row-span-2 aspect-[3/4]' : 'aspect-[4/3]'}`}
                data-testid={`in-action-image-${i}`}
              >
                <img
                  src={img.src}
                  alt={img.label}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-950/80 to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-3">
                  <span className="text-white text-xs sm:text-sm font-semibold">{img.label}</span>
                </div>
              </div>
            ))}
          </div>

          {/* Right: Content */}
          <div>
            <span className="text-cyan-400 text-sm font-semibold tracking-widest uppercase mb-4 block">
              See It In Action
            </span>
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-6 leading-tight">
              What It Looks Like
              <span className="block text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-violet-400">
                to Work With Us
              </span>
            </h2>
            <p className="text-slate-400 text-base sm:text-lg mb-8 leading-relaxed">
              Our sessions are designed to be hands-on, high-energy, and immediately applicable. We don't just lecture — we facilitate transformation through real engagement.
            </p>

            <div className="space-y-4">
              {bullets.map((item, i) => (
                <div key={i} className="flex items-center gap-3 p-3 rounded-xl bg-white/[0.03] border border-white/5" data-testid={`in-action-bullet-${i}`}>
                  <div className="w-10 h-10 rounded-lg bg-cyan-500/10 flex items-center justify-center flex-shrink-0">
                    <item.icon className="h-5 w-5 text-cyan-400" />
                  </div>
                  <span className="text-slate-200 text-sm sm:text-base font-medium">{item.text}</span>
                </div>
              ))}
            </div>

            {/* Micro CTA */}
            <button
              onClick={() => { trackCTAClick('Schedule a session like this', 'in_action'); document.querySelector('#consultation')?.scrollIntoView({ behavior: 'smooth' }); }}
              className="mt-6 inline-flex items-center gap-2 text-white font-semibold hover:text-cyan-400 transition-colors text-sm group/cta"
              data-testid="in-action-cta"
            >
              Schedule a session like this
              <ArrowRight className="h-4 w-4 group-hover/cta:translate-x-1 transition-transform" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InAction;
